import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FinexSidebarComponent } from './sidebar/sidebar.component';
import { MatButtonModule, MatIconModule, MatMenuModule, MatProgressSpinnerModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { LookupFieldComponent } from './lookup-field/lookup-field.component';

//** new import material */
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material';
import { MatTableModule } from '@angular/material/table';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { FinexFormModule } from '../finex-form/finex-form.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'; 

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [FinexSidebarComponent, LookupFieldComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    RouterModule,
    MatMenuModule, 
    HttpClientModule,
    NgxDropzoneModule,
    PerfectScrollbarModule,
    FinexFormModule,
    NgxSkeletonLoaderModule,

    //** material */
    MatFormFieldModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatInputModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatTableModule
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
  exports: [FinexSidebarComponent, LookupFieldComponent]
})
export class FinexComponentsModule { }
